/**
 * Kenshoo configuration, currently is always same for all websites
 */
export const conversionId = '7356';
export const infinityTagId = 'e5e509ff-3e73-4cfe-9ddf-234fa1c95966';

/**
 * Conversion type for infinity / pixel tracking
 */
export enum ConversionTypeEnum {
  registration = 'Registration',
  subscription = 'Subscription',
}
